"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LaptopSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M19 21a1 1 0 00-.89.55l-.5 1a.81.81 0 01-.74.46h-1.74a.81.81 0 01-.74-.46l-.5-1A1 1 0 0013 21H3a1 1 0 00-.77.37 1 1 0 00-.23.83l.38 1.8a5 5 0 004.9 4h17.44a5 5 0 004.9-4l.38-1.8a1 1 0 00-.21-.83A1 1 0 0029 21z"/><path d="M18 9a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1z"/><path d="M6 8a1 1 0 011-1h18a1 1 0 011 1v13h2V8a3 3 0 00-3-3H7a3 3 0 00-3 3v13h2z"/>';
var LaptopSVG = function LaptopSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LaptopSVG = LaptopSVG;
LaptopSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LaptopSVG);
exports.default = _default;